export default {"src":"/_next/static/media/bubble-question-mark.4325782e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};